import * as yup from 'yup'
import { MAXIMUM_IMAGE_SIZE } from '@/shared/utils/imageUploadUtility'
import { PHONE_NUMBER_REGEX } from '@/shared/config/constants'

// enum PARENT_ROLES {
//     PARENT,
//     TEACHER,
//     PARENT_TEACHER
// }

// enum PARENT_CHILD_RELATIONSHIPS {
//     FATHER,
//     MOTHER,
//     GUARDIAN,
//     PARENT
// }

const SignUpSchema = yup.object().shape({
    firstName: yup.string().required('First Name is required'),
    lastName: yup.string().required('Last Name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    password: yup
        .string()
        .required('Password is required')
        .min(6, 'Password must be at least 6 characters'),
    relationship: yup.string().required('Relationship is required'),
    role: yup.string().required('Role is required'),
    branch: yup
        .object({
            value: yup.string(),
            label: yup.string()
        })
        .required('Branch is required'),
    phoneNumber: yup
        .string()
        .matches(PHONE_NUMBER_REGEX, 'Phone number is not valid')
        .required('Phone Number is required'),
    picture: yup
        .mixed()
        .required()
        .test('noImage', 'Image is required', (value: any) => {
            return value && value[0]?.size
        })
        .test('fileSize', 'The file is too large', (value: any) => {
            return value && value[0]?.size <= MAXIMUM_IMAGE_SIZE
        }),
    children: yup.array()
})

export default SignUpSchema
